<div class="field documentary-record">
	<div class="info-row">
		<status-icon
			[number]="step"
			[complete]="
				unifiedPromptuary.form.get('serviceEvolutionPsychiatrist').valid
			"
		></status-icon>
		<div class="wrap-group">
			<div class="info">
				{{ 'PROMPTUARY.EVOLUTION_RECORD.TITLE' | translate }}
			</div>
			<div class="subinfo">
				{{ 'PROMPTUARY.EVOLUTION_RECORD.SUBTITLE_CRM' | translate }}
			</div>
		</div>
	</div>

	<div class="info">
		{{ 'PROMPTUARY.EVOLUTION_RECORD.CURRENT_DISEASE_HISTORY' | translate }}*
	</div>
	<autosave-textarea
		[fetchInitialValue]="false"
		[formControl]="
			unifiedPromptuary.form
				.get('serviceEvolutionPsychiatrist')
				.get('currentDiseaseHistory')
		"
		[initialValue]="
			unifiedPromptuary.form.get('serviceEvolutionPsychiatrist').value
				.currentDiseaseHistory
		"
		(valueSaving)="
			unifiedPromptuary.setAutoSaveLoading(
				'serviceEvolutionPsychiatrist.currentDiseaseHistory'
			)
		"
		(valueSaved)="
			unifiedPromptuary.autosaveComplete(
				'serviceEvolutionPsychiatrist.currentDiseaseHistory'
			)
		"
		[appointment]="autoSaveData"
		property="serviceEvolutionPsychiatrist.currentDiseaseHistory"
		service="autoSaveField"
	></autosave-textarea>

	<div class="info">
		{{ 'PROMPTUARY.EVOLUTION_RECORD.PERSONAL_BACKGROUND' | translate }}*
	</div>
	<autosave-textarea
		[fetchInitialValue]="false"
		[formControl]="
			unifiedPromptuary.form
				.get('serviceEvolutionPsychiatrist')
				.get('personalBackground')
		"
		[initialValue]="
			unifiedPromptuary.form.get('serviceEvolutionPsychiatrist').value
				.personalBackground
		"
		(valueSaving)="
			unifiedPromptuary.setAutoSaveLoading(
				'serviceEvolutionPsychiatrist.personalBackground'
			)
		"
		(valueSaved)="
			unifiedPromptuary.autosaveComplete(
				'serviceEvolutionPsychiatrist.personalBackground'
			)
		"
		[appointment]="autoSaveData"
		property="serviceEvolutionPsychiatrist.personalBackground"
		service="autoSaveField"
	></autosave-textarea>

	<div class="info">
		{{ 'PROMPTUARY.EVOLUTION_RECORD.FAMILY_BACKGROUND' | translate }}*
	</div>

	<autosave-textarea
		[fetchInitialValue]="false"
		[formControl]="
			unifiedPromptuary.form
				.get('serviceEvolutionPsychiatrist')
				.get('familyBackground')
		"
		[initialValue]="
			unifiedPromptuary.form.get('serviceEvolutionPsychiatrist').value
				.familyBackground
		"
		(valueSaving)="
			unifiedPromptuary.setAutoSaveLoading(
				'serviceEvolutionPsychiatrist.familyBackground'
			)
		"
		(valueSaved)="
			unifiedPromptuary.autosaveComplete(
				'serviceEvolutionPsychiatrist.familyBackground'
			)
		"
		[appointment]="autoSaveData"
		property="serviceEvolutionPsychiatrist.familyBackground"
		service="autoSaveField"
	></autosave-textarea>

	<div class="info">
		{{ 'PROMPTUARY.EVOLUTION_RECORD.HABITS_AND_VICES' | translate }}*
	</div>

	<autosave-textarea
		[fetchInitialValue]="false"
		[formControl]="
			unifiedPromptuary.form
				.get('serviceEvolutionPsychiatrist')
				.get('habitsAndVices')
		"
		[initialValue]="
			unifiedPromptuary.form.get('serviceEvolutionPsychiatrist').value
				.habitsAndVices
		"
		(valueSaving)="
			unifiedPromptuary.setAutoSaveLoading(
				'serviceEvolutionPsychiatrist.habitsAndVices'
			)
		"
		(valueSaved)="
			unifiedPromptuary.autosaveComplete(
				'serviceEvolutionPsychiatrist.habitsAndVices'
			)
		"
		[appointment]="autoSaveData"
		property="serviceEvolutionPsychiatrist.habitsAndVices"
		service="autoSaveField"
	></autosave-textarea>

	<div class="info">
		{{ 'PROMPTUARY.EVOLUTION_RECORD.MEDICATIONS_AND_DOSES' | translate }}*
	</div>

	<autosave-textarea
		[fetchInitialValue]="false"
		[formControl]="
			unifiedPromptuary.form
				.get('serviceEvolutionPsychiatrist')
				.get('medicationsAndDoses')
		"
		[initialValue]="
			unifiedPromptuary.form.get('serviceEvolutionPsychiatrist').value
				.medicationsAndDoses
		"
		(valueSaving)="
			unifiedPromptuary.setAutoSaveLoading(
				'serviceEvolutionPsychiatrist.medicationsAndDoses'
			)
		"
		(valueSaved)="
			unifiedPromptuary.autosaveComplete(
				'serviceEvolutionPsychiatrist.medicationsAndDoses'
			)
		"
		[appointment]="autoSaveData"
		property="serviceEvolutionPsychiatrist.medicationsAndDoses"
		service="autoSaveField"
	></autosave-textarea>
</div>
